export default __webpack_public_path__ + "static/media/boberContentNew1.474ed4f1.mp4";